export class PricingUnit {
    code: string;
    qty: number;
    constructor(code: string, qty?: number) {
        this.code = code;
        this.qty = qty ?? 1;
    }
}
